/* =============================================================================
   AppLovin -> Claude report tool
   -----------------------------------------------------------------------------
   Keo report tu Reporting API cua AppLovin qua mot Cloudflare Worker proxy
   (bat buoc, vi r.applovin.com khong tra header CORS), tong hop lai, ve bieu do,
   roi day sang Claude Opus 5 de phan tich.

   Khong luu tru gi tren server: Report Key nam trong localStorage cua may nguoi
   dung, API key cua Anthropic nam trong bien moi truong cua Worker.

   Xem applovin-proxy/README.md de biet cach deploy proxy.
   ========================================================================== */

(function () {
  'use strict';

  /* ======================================================================
     1. DANH MUC COT (theo tai lieu Reporting API cua AppLovin)
     ====================================================================== */

  var ADV_DIMS = [
    {
      g: 'Thời gian & campaign',
      items: [
        ['day', 'Ngày'],
        ['campaign', 'Campaign'],
        ['campaign_id_external', 'Campaign ID'],
        ['campaign_type', 'Loại campaign'],
        ['campaign_ad_type', 'Ad type của campaign'],
        ['campaign_package_name', 'Package name (app quảng cáo)'],
        ['campaign_store_id', 'Store ID của app'],
      ],
    },
    {
      g: 'Thị trường & thiết bị',
      items: [
        ['country', 'Quốc gia'],
        ['platform', 'Nền tảng'],
        ['device_type', 'Loại thiết bị'],
      ],
    },
    {
      g: 'Creative & placement',
      items: [
        ['creative_set', 'Creative set'],
        ['creative_set_id', 'Creative set ID'],
        ['ad', 'Ad'],
        ['ad_type', 'Ad type'],
        ['ad_creative_type', 'Creative type'],
        ['size', 'Kích thước'],
        ['placement_type', 'Loại placement'],
        ['external_placement_id', 'Placement ID'],
        ['custom_page_id', 'Custom page ID'],
      ],
    },
    {
      g: 'Nguồn & mục tiêu',
      items: [
        ['application', 'App (publisher)'],
        ['app_id_external', 'App ID (publisher)'],
        ['traffic_source', 'Traffic source'],
        ['target_event', 'Target event'],
        ['optimization_day_target', 'Optimization day target'],
      ],
    },
  ];

  var ADV_METS = [
    {
      g: 'Chỉ số cốt lõi',
      items: [
        ['cost', 'Chi phí (spend)'],
        ['impressions', 'Impressions'],
        ['clicks', 'Clicks'],
        ['conversions', 'Conversions (installs)'],
        ['ctr', 'CTR'],
        ['conversion_rate', 'CVR'],
        ['average_cpa', 'CPA/CPI trung bình'],
        ['average_cpc', 'CPC trung bình'],
        ['sales', 'Sales (doanh thu)'],
      ],
    },
    {
      g: 'Target event',
      items: [
        ['target_event_count', 'Số target event'],
        ['target_event_count_7d', 'Target event 7d'],
        ['cost_per_target_event_7d', 'Cost/target event 7d'],
      ],
    },
    {
      g: 'ROAS & retention (cohort)',
      items: [
        ['roas_1d', 'ROAS D1'],
        ['roas_7d', 'ROAS D7'],
        ['roas_30d', 'ROAS D30'],
        ['total_rev_1d', 'Doanh thu D1'],
        ['total_rev_7d', 'Doanh thu D7'],
        ['total_rev_30d', 'Doanh thu D30'],
        ['ad_rev_7d', 'Ad revenue D7'],
        ['ret_1d', 'Retention D1'],
        ['ret_7d', 'Retention D7'],
        ['cpp_7d', 'Cost per purchase D7'],
        ['sales_7d', 'Sales D7'],
      ],
    },
    {
      g: 'Mục tiêu campaign',
      items: [
        ['campaign_bid_goal', 'Bid goal'],
        ['campaign_roas_goal', 'ROAS goal'],
      ],
    },
  ];

  var PUB_DIMS = [
    {
      g: 'Thời gian',
      items: [
        ['day', 'Ngày'],
        ['hour', 'Giờ'],
      ],
    },
    {
      g: 'App & zone',
      items: [
        ['application', 'App'],
        ['package_name', 'Package name'],
        ['store_id', 'Store ID'],
        ['zone', 'Zone'],
        ['zone_id', 'Zone ID'],
        ['application_is_hidden', 'App đang ẩn?'],
      ],
    },
    {
      g: 'Thị trường & thiết bị',
      items: [
        ['country', 'Quốc gia'],
        ['platform', 'Nền tảng'],
        ['device_type', 'Loại thiết bị'],
      ],
    },
    {
      g: 'Định dạng',
      items: [
        ['ad_type', 'Ad type'],
        ['size', 'Kích thước'],
        ['placement_type', 'Loại placement'],
        ['bidding_integration', 'Bidding integration'],
      ],
    },
  ];

  var PUB_METS = [
    {
      g: 'Chỉ số',
      items: [
        ['impressions', 'Impressions'],
        ['clicks', 'Clicks'],
        ['ctr', 'CTR'],
        ['revenue', 'Doanh thu'],
        ['ecpm', 'eCPM'],
      ],
    },
  ];

  var ADV_PRESETS = [
    {
      name: 'Theo ngày + Campaign',
      dims: ['day', 'campaign'],
      mets: [
        'cost', 'impressions', 'clicks', 'conversions', 'ctr', 'conversion_rate',
        'average_cpa', 'average_cpc', 'sales', 'roas_1d', 'roas_7d', 'roas_30d',
        'total_rev_1d', 'total_rev_7d', 'total_rev_30d', 'ad_rev_7d',
        'ret_1d', 'ret_7d', 'campaign_bid_goal', 'campaign_roas_goal',
      ],
    },
    {
      name: 'Thêm Country + Platform',
      dims: ['day', 'campaign', 'country', 'platform'],
      mets: [
        'cost', 'impressions', 'clicks', 'conversions', 'ctr', 'conversion_rate',
        'average_cpa', 'average_cpc', 'sales', 'roas_1d', 'roas_7d',
      ],
    },
    {
      name: 'ROAS / Cohort',
      dims: ['day', 'campaign'],
      mets: [
        'cost', 'sales', 'roas_1d', 'roas_7d', 'roas_30d',
        'total_rev_1d', 'total_rev_7d', 'total_rev_30d',
        'ret_1d', 'ret_7d', 'cpp_7d', 'sales_7d',
      ],
    },
    {
      name: 'Creative level',
      dims: ['day', 'campaign', 'creative_set', 'ad'],
      mets: ['cost', 'impressions', 'clicks', 'ctr', 'average_cpc', 'sales', 'roas_7d'],
    },
  ];

  var PUB_PRESETS = [
    { name: 'Theo ngày + App', dims: ['day', 'application'], mets: ['impressions', 'clicks', 'ctr', 'revenue', 'ecpm'] },
    { name: 'Theo giờ', dims: ['day', 'hour', 'application'], mets: ['impressions', 'clicks', 'ctr', 'revenue', 'ecpm'] },
    { name: 'Theo zone', dims: ['day', 'application', 'zone'], mets: ['impressions', 'clicks', 'ctr', 'revenue', 'ecpm'] },
    { name: 'Theo quốc gia', dims: ['day', 'country', 'platform'], mets: ['impressions', 'revenue', 'ecpm'] },
  ];

  var FILTER_FIELDS = [
    ['country', 'Quốc gia', 'vd: US,VN,ID'],
    ['platform', 'Nền tảng', 'vd: android hoặc ios'],
    ['campaign', 'Tên campaign', 'khớp chính xác tên campaign'],
    ['campaign_id_external', 'Campaign ID', 'vd: 1234567'],
  ];

  /* Gia Claude Opus 5 (USD / 1 trieu token) */
  var PRICE_IN = 5;
  var PRICE_OUT = 25;

  var MAX_CTX_CHARS = 340000; /* ~100k token, con rat xa nguong 1M cua Opus 5 */

  var SERIES_SLOTS = ['--alv-s1', '--alv-s2', '--alv-s3', '--alv-s4', '--alv-s5'];

  /* Mot tooltip dung chung cho moi section — tranh ro ri node khi
     Theme Editor nap lai section nhieu lan. */
  var tip = null;
  function tooltipNode() {
    if (!tip || !tip.isConnected) {
      tip = document.querySelector('.alv-tip');
      if (!tip) {
        tip = document.createElement('div');
        tip.className = 'alv-tip';
        document.body.appendChild(tip);
      }
    }
    return tip;
  }

  /* ======================================================================
     2. TIEN ICH
     ====================================================================== */

  function el(tag, attrs, kids) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'class') node.className = v;
        else if (k === 'html') node.innerHTML = v;
        else if (k === 'text') node.textContent = v;
        else if (k.slice(0, 2) === 'on') node.addEventListener(k.slice(2), v);
        else node.setAttribute(k, v === true ? '' : v);
      });
    }
    (kids || []).forEach(function (kid) {
      if (kid === null || kid === undefined || kid === false) return;
      node.appendChild(typeof kid === 'string' ? document.createTextNode(kid) : kid);
    });
    return node;
  }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function utcToday() {
    var d = new Date();
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  }

  function isoDate(d) {
    return d.toISOString().slice(0, 10);
  }

  function addDays(d, n) {
    var x = new Date(d.getTime());
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  }

  function daysBetween(a, b) {
    return Math.round((Date.parse(b) - Date.parse(a)) / 86400000);
  }

  function num(v) {
    if (v === null || v === undefined || v === '') return 0;
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(/,/g, ''));
    return isFinite(n) ? n : 0;
  }

  function isCohort(col) {
    return /^(roas|ad_roas|ret|cpp|total_rev|ad_rev|sales|unique_purchasers|cost_per_target_event|target_event_count)_(\d+d|\d+y)$/.test(col);
  }

  function fmtKind(col) {
    if (/^(cost|sales|average_cpa|average_cpc|ecpm|revenue)$/.test(col)) return 'money';
    if (/^(total_rev|ad_rev|sales|cpp|cost_per_target_event)_(\d+d|\d+y)$/.test(col)) return 'money';
    if (/^(ctr|conversion_rate)$/.test(col)) return 'pct';
    if (/^(ret|roas|ad_roas)_(\d+d|\d+y)$/.test(col)) return 'pct';
    if (/goal$/.test(col)) return 'raw';
    return 'count';
  }

  function fmt(col, v) {
    if (v === null || v === undefined || (typeof v === 'number' && !isFinite(v))) return '—';
    var kind = fmtKind(col);
    if (kind === 'raw') return String(v);
    var n = num(v);
    if (kind === 'money') {
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    if (kind === 'pct') {
      return n.toLocaleString('en-US', { maximumFractionDigits: 2 }) + '%';
    }
    if (Math.abs(n - Math.round(n)) < 1e-9) return Math.round(n).toLocaleString('en-US');
    return n.toLocaleString('en-US', { maximumFractionDigits: 3 });
  }

  function compactMoney(n) {
    var a = Math.abs(n);
    if (a >= 1e9) return '$' + (n / 1e9).toFixed(1) + 'B';
    if (a >= 1e6) return '$' + (n / 1e6).toFixed(1) + 'M';
    if (a >= 1e3) return '$' + (n / 1e3).toFixed(1) + 'k';
    return '$' + n.toFixed(0);
  }

  function compactNum(n) {
    var a = Math.abs(n);
    if (a >= 1e9) return (n / 1e9).toFixed(1) + 'B';
    if (a >= 1e6) return (n / 1e6).toFixed(1) + 'M';
    if (a >= 1e3) return (n / 1e3).toFixed(1) + 'k';
    if (a >= 10) return n.toFixed(0);
    return n.toFixed(2);
  }

  function axisLabel(col, n) {
    var kind = fmtKind(col);
    if (kind === 'money') return compactMoney(n);
    if (kind === 'pct') return compactNum(n) + '%';
    return compactNum(n);
  }

  function store(key, val) {
    try {
      if (val === undefined) {
        var raw = localStorage.getItem(key);
        return raw === null ? undefined : JSON.parse(raw);
      }
      if (val === null) localStorage.removeItem(key);
      else localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {
      /* private mode */
    }
    return undefined;
  }

  /* ======================================================================
     3. TONG HOP (aggregate) — dung phep toan dung cho tung loai chi so
     ====================================================================== */

  var RATIO = {
    ctr: { n: 'clicks', d: 'impressions', k: 100 },
    conversion_rate: { n: 'conversions', d: 'clicks', k: 100 },
    average_cpa: { n: 'cost', d: 'conversions', k: 1 },
    average_cpc: { n: 'cost', d: 'clicks', k: 1 },
    ecpm: { n: 'revenue', d: 'impressions', k: 1000 },
  };

  function isAdditive(col) {
    if (/^(cost|impressions|clicks|conversions|sales|revenue|target_event_count)$/.test(col)) return true;
    return /^(total_rev|ad_rev|sales|unique_purchasers|target_event_count)_(\d+d|\d+y)$/.test(col);
  }

  function sumOf(rows, col) {
    var t = 0;
    for (var i = 0; i < rows.length; i += 1) t += num(rows[i][col]);
    return t;
  }

  function has(rows, col) {
    return rows.length > 0 && Object.prototype.hasOwnProperty.call(rows[0], col);
  }

  /**
   * Tong hop 1 chi so tren mot nhom dong.
   *  - Cong don:      cost, impressions, clicks, doanh thu...
   *  - Tinh lai ty le tu tu/mau khi co du cot (chinh xac tuyet doi)
   *  - ROAS: trung binh co trong so theo cost == sum(rev)/sum(cost) -> chinh xac
   *  - Retention: trong so theo conversions (installs)
   *  - CPP / cost-per-event: sum(cost) / sum(cost/gia_tri) -> chinh xac
   */
  function agg(rows, col) {
    if (!rows.length) return null;
    if (isAdditive(col)) return sumOf(rows, col);

    var r = RATIO[col];
    if (r && has(rows, r.n) && has(rows, r.d)) {
      var den = sumOf(rows, r.d);
      return den ? (sumOf(rows, r.n) / den) * r.k : null;
    }

    if (/^(cpp|cost_per_target_event)_(\d+d|\d+y)$/.test(col) && has(rows, 'cost')) {
      var top = 0;
      var bot = 0;
      for (var i = 0; i < rows.length; i += 1) {
        var c = num(rows[i].cost);
        var v = num(rows[i][col]);
        if (c > 0 && v > 0) {
          top += c;
          bot += c / v;
        }
      }
      return bot ? top / bot : null;
    }

    /* ROAS -> trong so cost, retention -> trong so conversions */
    var weightCol = null;
    if (/^(ret)_(\d+d|\d+y)$/.test(col) && has(rows, 'conversions')) weightCol = 'conversions';
    else if (has(rows, 'cost')) weightCol = 'cost';

    if (weightCol) {
      var wSum = 0;
      var vSum = 0;
      for (var j = 0; j < rows.length; j += 1) {
        var w = num(rows[j][weightCol]);
        if (w <= 0) continue;
        wSum += w;
        vSum += w * num(rows[j][col]);
      }
      if (wSum > 0) return vSum / wSum;
    }

    var plain = 0;
    var cnt = 0;
    for (var k = 0; k < rows.length; k += 1) {
      if (rows[k][col] === '' || rows[k][col] === null || rows[k][col] === undefined) continue;
      plain += num(rows[k][col]);
      cnt += 1;
    }
    return cnt ? plain / cnt : null;
  }

  function groupBy(rows, keys) {
    var map = new Map();
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i];
      var k = keys
        .map(function (c) {
          return row[c] === undefined || row[c] === null || row[c] === '' ? '(trống)' : String(row[c]);
        })
        .join(' · ');
      if (!map.has(k)) map.set(k, []);
      map.get(k).push(row);
    }
    return map;
  }

  /* ======================================================================
     4. MARKDOWN toi gian (cho cau tra loi cua Claude)
     ====================================================================== */

  function inlineMd(s) {
    return esc(s)
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s).,!?]|$)/g, '$1<em>$2</em>');
  }

  function mdToHtml(src) {
    var lines = String(src || '').split('\n');
    var out = [];
    var i = 0;

    function flushTable() {
      var head = lines[i];
      var sep = lines[i + 1];
      if (!/^\s*\|/.test(head) || !/^\s*\|?[\s:|-]+\|/.test(sep || '')) return false;
      var cells = function (line) {
        return line.trim().replace(/^\||\|$/g, '').split('|').map(function (c) { return c.trim(); });
      };
      var html = '<table><thead><tr>';
      cells(head).forEach(function (c) { html += '<th>' + inlineMd(c) + '</th>'; });
      html += '</tr></thead><tbody>';
      i += 2;
      while (i < lines.length && /^\s*\|/.test(lines[i])) {
        html += '<tr>';
        cells(lines[i]).forEach(function (c) { html += '<td>' + inlineMd(c) + '</td>'; });
        html += '</tr>';
        i += 1;
      }
      out.push(html + '</tbody></table>');
      return true;
    }

    while (i < lines.length) {
      var line = lines[i];

      if (/^\s*```/.test(line)) {
        var buf = [];
        i += 1;
        while (i < lines.length && !/^\s*```/.test(lines[i])) { buf.push(lines[i]); i += 1; }
        i += 1;
        out.push('<pre><code>' + esc(buf.join('\n')) + '</code></pre>');
        continue;
      }

      if (/^\s*\|/.test(line) && flushTable()) continue;

      var h = line.match(/^(#{1,6})\s+(.*)$/);
      if (h) {
        var lvl = Math.min(h[1].length + 2, 5);
        out.push('<h' + lvl + '>' + inlineMd(h[2]) + '</h' + lvl + '>');
        i += 1;
        continue;
      }

      if (/^\s*[-*+]\s+/.test(line)) {
        var ul = '<ul>';
        while (i < lines.length && /^\s*[-*+]\s+/.test(lines[i])) {
          ul += '<li>' + inlineMd(lines[i].replace(/^\s*[-*+]\s+/, '')) + '</li>';
          i += 1;
        }
        out.push(ul + '</ul>');
        continue;
      }

      if (/^\s*\d+[.)]\s+/.test(line)) {
        var ol = '<ol>';
        while (i < lines.length && /^\s*\d+[.)]\s+/.test(lines[i])) {
          ol += '<li>' + inlineMd(lines[i].replace(/^\s*\d+[.)]\s+/, '')) + '</li>';
          i += 1;
        }
        out.push(ol + '</ol>');
        continue;
      }

      if (!line.trim()) { i += 1; continue; }

      var para = [];
      while (i < lines.length && lines[i].trim() && !/^\s*([-*+]\s|\d+[.)]\s|#{1,6}\s|\||```)/.test(lines[i])) {
        para.push(lines[i]);
        i += 1;
      }
      out.push('<p>' + inlineMd(para.join(' ')) + '</p>');
    }

    return out.join('');
  }

  /* ======================================================================
     5. SYSTEM PROMPT cho Claude
     ====================================================================== */

  var SYSTEM_PROMPT = [
    'Bạn là chuyên gia phân tích hiệu quả quảng cáo (performance media buyer) chuyên về AppLovin AppDiscovery.',
    'Người dùng đưa cho bạn dữ liệu thô kéo trực tiếp từ Reporting API của AppLovin. Trả lời bằng tiếng Việt.',
    '',
    '## Cách đọc dữ liệu',
    '- Mọi mốc thời gian đều theo UTC, không phải giờ Việt Nam.',
    '- `cost` là chi phí USD. `sales` là doanh thu quy đổi mà AppLovin ghi nhận.',
    '- `roas_1d/7d/30d` và `ret_1d/7d` là **phần trăm** (226.07 nghĩa là 226%, tức hoà vốn ở mốc 100%).',
    '- `ctr`, `conversion_rate` cũng là phần trăm.',
    '- `conversions` là install. Với campaign web/ecommerce cột này thường bằng 0 — khi đó **đừng** kết luận "không có chuyển đổi";',
    '  hãy đánh giá bằng `sales` và `roas_*` thay vì CPI.',
    '- Cột `*_1d/7d/30d` là chỉ số **cohort**: gán theo ngày người dùng được acquire, không phải ngày phát sinh doanh thu.',
    '',
    '## Kỷ luật bắt buộc',
    '- Cohort D7/D30 của những ngày gần đây **chưa chín**. Với ngày cách hôm nay dưới 7 (hoặc 30) ngày, con số còn tăng tiếp.',
    '  Luôn nói rõ điều này trước khi nhận xét, và đừng so ngày mới với ngày cũ như thể chúng tương đương.',
    '- Kiểm tra cỡ mẫu trước khi kết luận. Một campaign tiêu $40 với 3 đơn thì ROAS không có ý nghĩa thống kê — hãy nói thẳng.',
    '- Khi tổng hợp: cộng dồn cost/impressions/clicks/doanh thu; tính lại tỷ lệ từ tử số và mẫu số',
    '  (CTR = clicks/impressions, ROAS gộp = tổng doanh thu / tổng chi phí). Không bao giờ lấy trung bình cộng của các tỷ lệ.',
    '- Chỉ dùng con số có trong dữ liệu. Nếu thiếu dữ liệu để trả lời, nói rõ thiếu cột nào và cần kéo thêm gì.',
    '- Nêu rõ khi một thay đổi nằm trong nhiễu ngày-qua-ngày thay vì là xu hướng thật.',
    '',
    '## Cách trả lời',
    'Mở đầu bằng kết luận — một đoạn ngắn trả lời đúng câu được hỏi. Chi tiết và lập luận để phía sau.',
    'Dùng bảng markdown khi so sánh nhiều campaign. Đưa số kèm đơn vị.',
    'Kết thúc bằng các hành động cụ thể (tăng/giảm ngân sách bao nhiêu, tắt cái gì, cần theo dõi thêm chỉ số nào),',
    'chỉ khi dữ liệu thực sự đủ để đề xuất. Ngắn gọn, không lặp lại số liệu đã hiển thị trên bảng trừ khi cần cho lập luận.',
  ].join('\n');

  /* ======================================================================
     6. APP
     ====================================================================== */

  function init(root) {
    var cfgEl = root.querySelector('[data-alv-config]');
    var settings = {};
    try {
      settings = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {};
    } catch (e) {
      settings = {};
    }

    var NS = 'alv:' + (settings.ns || 'default') + ':';
    var mount = root.querySelector('[data-alv-mount]');

    var state = {
      proxyUrl: store(NS + 'proxy') || settings.proxyUrl || '',
      proxySecret: store(NS + 'secret') || '',
      reportKey: store(NS + 'key') || '',
      remember: store(NS + 'remember') !== false,
      reportType: 'advertiser',
      dims: [],
      mets: [],
      filters: {},
      extraCols: '',
      notZero: true,
      compare: true,
      limit: '',
      start: '',
      end: '',
      health: null,
      rows: [],
      prevRows: [],
      meta: null,
      sort: { col: null, dir: -1 },
      chart: { bar: 'cost', line: '', split: '', mode: '' },
      pivotDim: '',
      autoMin: 0,
      autoTimer: null,
      colorMap: {},
      chat: [],
      dataBlock: '',
      busy: false,
      abort: null,
    };

    var days = Math.max(1, Math.min(45, parseInt(settings.defaultDays, 10) || 14));
    state.end = isoDate(utcToday());
    state.start = isoDate(addDays(utcToday(), -(days - 1)));

    applyPreset(ADV_PRESETS[0]);

    /* ---------------- helpers gan lien voi state ---------------- */

    function catalog() {
      return state.reportType === 'publisher'
        ? { dims: PUB_DIMS, mets: PUB_METS, presets: PUB_PRESETS }
        : { dims: ADV_DIMS, mets: ADV_METS, presets: ADV_PRESETS };
    }

    function applyPreset(p) {
      state.dims = p.dims.slice();
      state.mets = p.mets.slice();
      state.colorMap = {};
    }

    function labelOf(id) {
      var all = catalog().dims.concat(catalog().mets);
      for (var i = 0; i < all.length; i += 1) {
        for (var j = 0; j < all[i].items.length; j += 1) {
          if (all[i].items[j][0] === id) return all[i].items[j][1];
        }
      }
      return id;
    }

    function selectedCols() {
      var extra = state.extraCols
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      return state.dims.concat(state.mets).concat(extra);
    }

    function metricCols() {
      if (!state.rows.length) return state.mets.slice();
      return state.mets.filter(function (m) { return has(state.rows, m); });
    }

    function seriesColor(name) {
      if (name === '__other__') return 'var(--alv-s-other)';
      if (state.colorMap[name] === undefined) {
        var used = Object.keys(state.colorMap).length;
        state.colorMap[name] = used < SERIES_SLOTS.length ? used : -1;
      }
      var slot = state.colorMap[name];
      return slot < 0 ? 'var(--alv-s-other)' : 'var(' + SERIES_SLOTS[slot] + ')';
    }

    /* ---------------- goi proxy ---------------- */

    function proxyBase() {
      return String(state.proxyUrl || '').replace(/\/+$/, '');
    }

    /* /health la route cong khai (khong can secret) — dung de biet worker
       da co san Report Key hay chua, tu do quyet dinh co bat nguoi dung
       nhap key khong. */
    async function probeHealth() {
      if (!proxyBase()) return null;
      try {
        var res = await fetch(proxyBase() + '/health', { method: 'GET' });
        if (!res.ok) return null;
        return await res.json();
      } catch (e) {
        return null;
      }
    }

    function serverHasKey() {
      return !!(state.health && state.health.has_applovin_key);
    }

    async function callProxy(path, payload, signal) {
      if (!proxyBase()) throw new Error('Chưa cấu hình URL proxy.');
      var headers = { 'content-type': 'application/json' };
      if (state.proxySecret) headers['X-Proxy-Secret'] = state.proxySecret;

      var res;
      try {
        res = await fetch(proxyBase() + path, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload),
          signal: signal,
        });
      } catch (e) {
        if (e.name === 'AbortError') throw e;
        throw new Error('Không kết nối được tới proxy. Kiểm tra URL, worker đã deploy chưa, và ALLOWED_ORIGINS có domain này chưa.');
      }
      return res;
    }

    async function callJson(path, payload) {
      var res = await callProxy(path, payload);
      var text = await res.text();
      var data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        throw new Error('Proxy trả về dữ liệu không phải JSON: ' + text.slice(0, 200));
      }
      if (!res.ok) throw new Error(data.error || 'Lỗi ' + res.status + (data.detail ? ' — ' + data.detail : ''));
      return data;
    }

    function buildParams(startDate, endDate) {
      var cols = selectedCols();
      var p = {
        start: startDate,
        end: endDate,
        format: 'json',
        report_type: state.reportType,
        columns: cols.join(','),
      };
      if (state.notZero) p.not_zero = 1;
      if (state.limit) p.limit = state.limit;
      if (cols.some(isCohort)) p.day_column = 'day';
      Object.keys(state.filters).forEach(function (k) {
        var v = String(state.filters[k] || '').trim();
        if (v) p['filter_' + k] = v;
      });
      return p;
    }

    function extractRows(data) {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.results)) return data.results;
      if (data && Array.isArray(data.data)) return data.data;
      if (data && typeof data === 'object') {
        var keys = Object.keys(data);
        for (var i = 0; i < keys.length; i += 1) {
          if (Array.isArray(data[keys[i]])) return data[keys[i]];
        }
      }
      return [];
    }

    function coerce(rows) {
      var cols = selectedCols();
      return rows.map(function (r) {
        var o = {};
        cols.forEach(function (c) {
          if (!Object.prototype.hasOwnProperty.call(r, c)) return;
          o[c] = state.mets.indexOf(c) >= 0 || isCohort(c) ? num(r[c]) : r[c];
        });
        Object.keys(r).forEach(function (k) {
          if (!Object.prototype.hasOwnProperty.call(o, k)) o[k] = r[k];
        });
        return o;
      });
    }

    /* ================================================================
       7. RENDER — man hinh nhap key
       ================================================================ */

    function renderGate(errMsg) {
      mount.innerHTML = '';

      var onServer = serverHasKey();

      var keyInput = el('input', {
        class: 'alv-input', type: 'password', autocomplete: 'off', spellcheck: 'false',
        placeholder: onServer ? 'Để trống — worker đã có sẵn key' : 'Dán Reporting Key của AppLovin',
        value: state.reportKey,
      });
      var proxyInput = el('input', {
        class: 'alv-input', type: 'url', spellcheck: 'false',
        placeholder: 'https://applovin-proxy.xxx.workers.dev', value: state.proxyUrl,
      });
      var secretInput = el('input', {
        class: 'alv-input', type: 'password', autocomplete: 'off', spellcheck: 'false',
        placeholder: 'Bỏ trống nếu worker không đặt PROXY_SECRET', value: state.proxySecret,
      });
      var rememberBox = el('input', { type: 'checkbox', checked: state.remember });
      var status = el('div');
      var btn = el('button', { class: 'alv-btn alv-btn--primary', type: 'button' }, ['Kết nối']);

      if (errMsg) status.appendChild(el('div', { class: 'alv-alert alv-alert--err', html: esc(errMsg) }));

      btn.addEventListener('click', async function () {
        state.reportKey = keyInput.value.trim();
        state.proxyUrl = proxyInput.value.trim();
        state.proxySecret = secretInput.value.trim();
        state.remember = rememberBox.checked;

        if (!state.proxyUrl) { flash('Cần URL của Cloudflare Worker proxy.'); return; }

        btn.disabled = true;
        btn.innerHTML = '';
        btn.appendChild(el('span', { class: 'alv-spin' }));
        btn.appendChild(document.createTextNode(' Đang kiểm tra...'));

        try {
          /* Do lai xem worker co san key khong (URL proxy co the vua doi) */
          state.health = await probeHealth();
          if (!state.reportKey && !serverHasKey()) {
            flash(
              'Cần Reporting Key của AppLovin. Muốn khỏi phải nhập mỗi lần: thêm Secret ' +
                'APPLOVIN_REPORT_KEY vào worker rồi tải lại trang.'
            );
            return;
          }

          var probeEnd = isoDate(utcToday());
          var probeStart = isoDate(addDays(utcToday(), -2));
          await callJson('/applovin', {
            reportKey: state.reportKey,
            params: {
              start: probeStart, end: probeEnd, format: 'json',
              report_type: state.reportType, columns: 'day,cost', limit: 1,
            },
          });

          if (state.remember) {
            store(NS + 'key', state.reportKey);
            store(NS + 'proxy', state.proxyUrl);
            store(NS + 'secret', state.proxySecret);
            store(NS + 'remember', true);
          } else {
            store(NS + 'key', null);
            store(NS + 'remember', false);
            store(NS + 'proxy', state.proxyUrl);
            store(NS + 'secret', state.proxySecret);
          }
          renderApp();
          fetchReport();
        } catch (e) {
          flash(e.message);
        }
      });

      function flash(msg) {
        btn.disabled = false;
        btn.textContent = 'Kết nối';
        status.innerHTML = '';
        status.appendChild(el('div', { class: 'alv-alert alv-alert--err', html: esc(msg) }));
      }

      mount.appendChild(
        el('div', { class: 'alv-card alv-card--gate' }, [
          el('h3', { class: 'alv-card__title', text: 'Kết nối AppLovin' }),
          el('p', {
            class: 'alv-sub',
            text: 'Key chỉ nằm trên máy này (localStorage) và đi qua proxy của bạn. Không có gì được lưu trên server Shopify.',
          }),
          status,
          el('div', { class: 'alv-group' }, [
            el('label', {
              class: 'alv-label',
              text: onServer ? 'Reporting Key (AppLovin) — không bắt buộc' : 'Reporting Key (AppLovin)',
            }),
            keyInput,
            el('div', {
              class: 'alv-hint',
              text: onServer
                ? 'Worker đã có sẵn key nên bạn cứ bấm Kết nối. Chỉ nhập vào đây nếu muốn dùng key của tài khoản AppLovin khác.'
                : 'Lấy ở dashboard AppLovin: Account → Keys → Report Key. Muốn khỏi nhập lại mỗi lần vào web: thêm Secret APPLOVIN_REPORT_KEY vào worker.',
            }),
          ]),
          el('div', { class: 'alv-group' }, [
            el('label', { class: 'alv-label', text: 'URL proxy (Cloudflare Worker)' }),
            proxyInput,
            el('div', {
              class: 'alv-hint',
              text: 'Bắt buộc — AppLovin không trả header CORS nên trình duyệt không gọi thẳng được. Code worker nằm trong thư mục applovin-proxy/.',
            }),
          ]),
          el('div', { class: 'alv-group' }, [
            el('label', { class: 'alv-label', text: 'Mã bảo vệ proxy (PROXY_SECRET)' }),
            secretInput,
          ]),
          el('div', { class: 'alv-group' }, [
            el('label', { class: 'alv-check' }, [rememberBox, 'Ghi nhớ trên máy này']),
          ]),
          btn,
        ])
      );
    }

    /* ================================================================
       8. RENDER — giao dien chinh
       ================================================================ */

    var refs = {};

    function renderApp() {
      mount.innerHTML = '';
      refs = {};

      /* --- header --- */
      var changeBtn = el('button', { class: 'alv-btn alv-btn--sm alv-btn--ghost', type: 'button' }, ['Đổi key']);
      changeBtn.addEventListener('click', function () {
        stopAuto();
        renderGate();
      });

      mount.appendChild(
        el('div', { class: 'alv-head' }, [
          el('div', { class: 'alv-head__row' }, [
            el('div', {}, [
              el('h2', { text: settings.title || 'AppLovin → Claude' }),
              el('p', {
                text:
                  settings.subtitle ||
                  'Kéo report từ Reporting API, tổng hợp lại rồi đẩy sang Claude Opus 5 để phân tích. Không lưu trữ — mở web là tự kéo số mới nhất.',
              }),
            ]),
            el('div', { class: 'alv-head__actions' }, [changeBtn]),
          ]),
        ])
      );

      /* --- tabs advertiser / publisher --- */
      if (settings.showPublisher) {
        var tabs = el('div', { class: 'alv-tabs' });
        [['advertiser', 'Advertiser (AppDiscovery)'], ['publisher', 'Publisher (MAX)']].forEach(function (t) {
          var b = el('button', { class: 'alv-tab' + (state.reportType === t[0] ? ' is-on' : ''), type: 'button', text: t[1] });
          b.addEventListener('click', function () {
            if (state.reportType === t[0]) return;
            state.reportType = t[0];
            applyPreset(catalog().presets[0]);
            state.rows = [];
            state.prevRows = [];
            state.chart = { bar: state.reportType === 'publisher' ? 'revenue' : 'cost', line: '', split: '', mode: '' };
            renderApp();
          });
          tabs.appendChild(b);
        });
        mount.appendChild(tabs);
      }

      mount.appendChild(buildQueryCard());
      refs.stats = el('div');
      mount.appendChild(refs.stats);
      refs.charts = el('div');
      mount.appendChild(refs.charts);
      refs.pivot = el('div');
      mount.appendChild(refs.pivot);
      refs.table = el('div');
      mount.appendChild(refs.table);
      refs.claude = el('div');
      mount.appendChild(refs.claude);

      renderResults();
      renderClaude();
    }

    /* ---------------- card 1: chon du lieu ---------------- */

    function buildQueryCard() {
      var cat = catalog();

      /* preset nhanh */
      var presetRow = el('div', { class: 'alv-chips', style: 'margin-bottom:16px' });
      cat.presets.forEach(function (p) {
        var b = el('button', { class: 'alv-chip alv-chip--preset', type: 'button', text: p.name });
        b.addEventListener('click', function () {
          applyPreset(p);
          renderApp();
        });
        presetRow.appendChild(b);
      });

      /* ngay + gioi han */
      var startIn = el('input', { class: 'alv-input', type: 'date', value: state.start });
      var endIn = el('input', { class: 'alv-input', type: 'date', value: state.end });
      var limitIn = el('input', { class: 'alv-input', type: 'number', min: '1', placeholder: 'không giới hạn', value: state.limit });
      startIn.addEventListener('change', function () { state.start = startIn.value; refreshRangeWarn(); });
      endIn.addEventListener('change', function () { state.end = endIn.value; refreshRangeWarn(); });
      limitIn.addEventListener('change', function () { state.limit = limitIn.value; });

      var zeroBox = el('input', { type: 'checkbox', checked: state.notZero });
      zeroBox.addEventListener('change', function () { state.notZero = zeroBox.checked; });
      var cmpBox = el('input', { type: 'checkbox', checked: state.compare });
      cmpBox.addEventListener('change', function () { state.compare = cmpBox.checked; });

      var runBtn = el('button', { class: 'alv-btn alv-btn--primary', type: 'button', text: 'Kéo dữ liệu' });
      runBtn.addEventListener('click', function () { fetchReport(); });
      refs.runBtn = runBtn;

      refs.rangeWarn = el('div');

      var topRow = el('div', { class: 'alv-row' }, [
        el('div', { class: 'alv-field' }, [el('label', { class: 'alv-label', text: 'Từ ngày (UTC)' }), startIn]),
        el('div', { class: 'alv-field' }, [el('label', { class: 'alv-label', text: 'Đến ngày (UTC)' }), endIn]),
        el('div', { class: 'alv-field' }, [el('label', { class: 'alv-label', text: 'Giới hạn dòng' }), limitIn]),
        el('div', { class: 'alv-field', style: 'flex:0 1 240px' }, [
          el('label', { class: 'alv-check', style: 'margin-bottom:8px' }, [zeroBox, 'Bỏ dòng toàn số 0']),
          el('label', { class: 'alv-check' }, [cmpBox, 'Kéo thêm kỳ trước để so sánh']),
        ]),
        el('div', { class: 'alv-spacer' }),
        el('div', {}, [runBtn]),
      ]);

      /* chip chieu & chi so */
      function chipBoard(groups, listName) {
        var wrap = el('div');
        groups.forEach(function (grp) {
          var box = el('div', { class: 'alv-colgroup' }, [el('div', { class: 'alv-colgroup__title', text: grp.g })]);
          var chips = el('div', { class: 'alv-chips' });
          grp.items.forEach(function (item) {
            var id = item[0];
            var on = state[listName].indexOf(id) >= 0;
            var chip = el('button', { class: 'alv-chip' + (on ? ' is-on' : ''), type: 'button' }, [
              document.createTextNode(item[1]),
              el('code', { text: id }),
            ]);
            chip.addEventListener('click', function () {
              var idx = state[listName].indexOf(id);
              if (idx >= 0) state[listName].splice(idx, 1);
              else state[listName].push(id);
              if (listName === 'dims') state.colorMap = {};
              renderApp();
            });
            chips.appendChild(chip);
          });
          box.appendChild(chips);
          wrap.appendChild(box);
        });
        return wrap;
      }

      var cohortOn = selectedCols().some(isCohort);

      /* bo loc */
      var filterRow = el('div', { class: 'alv-grid4' });
      FILTER_FIELDS.forEach(function (f) {
        var input = el('input', { class: 'alv-input', type: 'text', placeholder: f[2], value: state.filters[f[0]] || '' });
        input.addEventListener('input', function () { state.filters[f[0]] = input.value; });
        filterRow.appendChild(el('div', {}, [el('label', { class: 'alv-label', text: f[1] }), input]));
      });

      var extraIn = el('input', {
        class: 'alv-input', type: 'text', value: state.extraCols,
        placeholder: 'vd: roas_14d,total_rev_90d,unique_purchasers_7d',
      });
      extraIn.addEventListener('change', function () { state.extraCols = extraIn.value; });

      /* preset da luu + auto refresh */
      var autoSel = el('select', { class: 'alv-select' });
      [[0, 'Tắt'], [5, 'Mỗi 5 phút'], [15, 'Mỗi 15 phút'], [30, 'Mỗi 30 phút'], [60, 'Mỗi 60 phút']].forEach(function (o) {
        autoSel.appendChild(el('option', { value: String(o[0]), selected: state.autoMin === o[0], text: o[1] }));
      });
      autoSel.addEventListener('change', function () {
        state.autoMin = parseInt(autoSel.value, 10) || 0;
        startAuto();
      });

      var saveBtn = el('button', { class: 'alv-btn alv-btn--sm', type: 'button', text: '+ Lưu preset hiện tại' });
      saveBtn.addEventListener('click', function () {
        var name = window.prompt('Tên preset:');
        if (!name) return;
        var saved = store(NS + 'presets') || [];
        saved = saved.filter(function (s) { return s.name !== name; });
        saved.push({
          name: name,
          reportType: state.reportType,
          dims: state.dims.slice(),
          mets: state.mets.slice(),
          filters: JSON.parse(JSON.stringify(state.filters)),
          extraCols: state.extraCols,
          notZero: state.notZero,
          limit: state.limit,
          days: Math.abs(daysBetween(state.start, state.end)) + 1,
        });
        store(NS + 'presets', saved);
        renderApp();
      });

      var savedBar = el('div', { class: 'alv-presetbar' }, [saveBtn]);
      (store(NS + 'presets') || []).forEach(function (p) {
        var pill = el('div', { class: 'alv-savedpreset' });
        var load = el('button', { type: 'button', text: p.name });
        load.addEventListener('click', function () {
          state.reportType = p.reportType || 'advertiser';
          state.dims = (p.dims || []).slice();
          state.mets = (p.mets || []).slice();
          state.filters = p.filters || {};
          state.extraCols = p.extraCols || '';
          state.notZero = p.notZero !== false;
          state.limit = p.limit || '';
          state.end = isoDate(utcToday());
          state.start = isoDate(addDays(utcToday(), -((p.days || 14) - 1)));
          state.colorMap = {};
          renderApp();
          fetchReport();
        });
        var del = el('button', { type: 'button', title: 'Xoá preset', text: '×' });
        del.addEventListener('click', function () {
          store(NS + 'presets', (store(NS + 'presets') || []).filter(function (s) { return s.name !== p.name; }));
          renderApp();
        });
        pill.appendChild(load);
        pill.appendChild(del);
        savedBar.appendChild(pill);
      });
      savedBar.appendChild(el('div', { class: 'alv-spacer' }));
      savedBar.appendChild(el('label', { class: 'alv-label', style: 'margin:0 8px 0 0;align-self:center', text: 'Tự kéo lại' }));
      savedBar.appendChild(el('div', { style: 'width:150px' }, [autoSel]));

      var card = el('div', { class: 'alv-card' }, [
        el('h3', { class: 'alv-card__title', text: '1. Chọn dữ liệu cần kéo về' }),
        presetRow,
        topRow,
        refs.rangeWarn,
        el('div', { class: 'alv-grid2', style: 'margin-top:26px' }, [
          el('div', {}, [
            el('div', { class: 'alv-card__title', style: 'font-size:14px' }, [
              document.createTextNode('Chiều dữ liệu đã chọn '),
              el('span', { class: 'alv-count', text: String(state.dims.length) }),
            ]),
            chipBoard(cat.dims, 'dims'),
          ]),
          el('div', {}, [
            el('div', { class: 'alv-card__title', style: 'font-size:14px' }, [
              document.createTextNode('Chỉ số đã chọn '),
              el('span', { class: 'alv-count', text: String(state.mets.length) }),
            ]),
            chipBoard(cat.mets, 'mets'),
          ]),
        ]),
        cohortOn
          ? el('div', { class: 'alv-note', style: 'margin-bottom:18px' }, [
              document.createTextNode('Có chỉ số cohort (ROAS/retention) → app tự thêm '),
              el('code', { text: 'day_column=day' }),
              document.createTextNode(' vào request. Lưu ý: cohort D7/D30 của những ngày gần đây '),
              el('strong', { text: 'chưa chín' }),
              document.createTextNode(', đừng vội kết luận từ chúng.'),
            ])
          : null,
        el('div', { class: 'alv-colgroup__title', text: 'Bộ lọc (tuỳ chọn — khớp chính xác, nhiều giá trị cách nhau bởi dấu phẩy)' }),
        filterRow,
        el('div', { style: 'margin-top:14px' }, [
          el('label', { class: 'alv-label', text: 'Thêm cột thủ công (bất kỳ cột nào API hỗ trợ)' }),
          extraIn,
          el('div', {
            class: 'alv-hint',
            text: 'Cửa sổ hợp lệ cho chỉ số cohort: 0d, 1d, 2d, 3d, 7d, 14d, 28d, 30d, 90d, 1y.',
          }),
        ]),
        savedBar,
      ]);

      refreshRangeWarn();
      return card;
    }

    function refreshRangeWarn() {
      if (!refs.rangeWarn) return;
      refs.rangeWarn.innerHTML = '';
      if (!state.start || !state.end) return;
      var span = daysBetween(state.start, state.end);
      if (span < 0) {
        refs.rangeWarn.appendChild(el('div', { class: 'alv-alert alv-alert--err', style: 'margin-top:14px', text: 'Ngày kết thúc đang sớm hơn ngày bắt đầu.' }));
      } else if (state.dims.indexOf('hour') >= 0 && span > 29) {
        refs.rangeWarn.appendChild(
          el('div', { class: 'alv-alert alv-alert--warn', style: 'margin-top:14px' }, [
            document.createTextNode('Đang chọn chiều '),
            el('code', { text: 'hour' }),
            document.createTextNode(' với khoảng ' + (span + 1) + ' ngày. Dữ liệu theo giờ chỉ có trong '),
            el('strong', { text: '30 ngày gần nhất' }),
            document.createTextNode(' — những ngày cũ hơn sẽ trống.'),
          ])
        );
      } else if (span > 44) {
        refs.rangeWarn.appendChild(
          el('div', { class: 'alv-alert alv-alert--warn', style: 'margin-top:14px' }, [
            document.createTextNode('Khoảng đang chọn là ' + (span + 1) + ' ngày. Reporting API chỉ cho tối đa '),
            el('strong', { text: '45 ngày' }),
            document.createTextNode(' — request sẽ bị từ chối.'),
          ])
        );
      }
    }

    /* ================================================================
       9. KEO DU LIEU
       ================================================================ */

    async function fetchReport() {
      if (state.busy) return;
      if (!state.mets.length && !state.dims.length) {
        showError('Chọn ít nhất một chiều dữ liệu hoặc một chỉ số.');
        return;
      }

      state.busy = true;
      if (refs.runBtn) {
        refs.runBtn.disabled = true;
        refs.runBtn.innerHTML = '';
        refs.runBtn.appendChild(el('span', { class: 'alv-spin' }));
        refs.runBtn.appendChild(document.createTextNode(' Đang kéo dữ liệu...'));
      }
      markStale(true);

      try {
        var main = await callJson('/applovin', { reportKey: state.reportKey, params: buildParams(state.start, state.end) });
        state.rows = coerce(extractRows(main));

        state.prevRows = [];
        state.meta = null;
        if (state.compare) {
          var span = daysBetween(state.start, state.end) + 1;
          var prevEnd = isoDate(addDays(new Date(Date.parse(state.start)), -1));
          var prevStart = isoDate(addDays(new Date(Date.parse(state.start)), -span));
          try {
            var prev = await callJson('/applovin', { reportKey: state.reportKey, params: buildParams(prevStart, prevEnd) });
            state.prevRows = coerce(extractRows(prev));
            state.meta = { prevStart: prevStart, prevEnd: prevEnd };
          } catch (e) {
            state.meta = { prevError: e.message };
          }
        }

        state.sort = { col: null, dir: -1 };
        buildDataBlock();
        renderResults();
        renderClaude();
      } catch (e) {
        showError(e.message);
      } finally {
        state.busy = false;
        markStale(false);
        if (refs.runBtn) {
          refs.runBtn.disabled = false;
          refs.runBtn.textContent = 'Kéo dữ liệu';
        }
      }
    }

    function markStale(on) {
      [refs.charts, refs.pivot, refs.table].forEach(function (n) {
        if (!n) return;
        n.querySelectorAll('.alv-figure').forEach(function (f) { f.classList.toggle('is-stale', !!on); });
      });
    }

    function showError(msg) {
      if (!refs.stats) return;
      refs.stats.innerHTML = '';
      refs.stats.appendChild(el('div', { class: 'alv-alert alv-alert--err', html: esc(msg) }));
    }

    function startAuto() {
      stopAuto();
      if (state.autoMin > 0) {
        state.autoTimer = setInterval(function () { fetchReport(); }, state.autoMin * 60000);
      }
    }

    function stopAuto() {
      if (state.autoTimer) clearInterval(state.autoTimer);
      state.autoTimer = null;
    }

    /* ================================================================
       10. KET QUA: stat tiles + bieu do + pivot + bang tho
       ================================================================ */

    function renderResults() {
      renderStats();
      renderCharts();
      renderPivot();
      renderTable();
    }

    function deltaNode(cur, prev, col) {
      if (prev === null || prev === undefined || !isFinite(prev) || prev === 0) return null;
      var pct = ((cur - prev) / Math.abs(prev)) * 100;
      var cls = Math.abs(pct) < 0.5 ? 'flat' : pct > 0 ? 'up' : 'down';
      var sign = pct > 0 ? '+' : '';
      return el('div', {
        class: 'alv-delta alv-delta--' + cls,
        text: sign + pct.toFixed(1) + '% so với kỳ trước (' + fmt(col, prev) + ')',
      });
    }

    function renderStats() {
      refs.stats.innerHTML = '';
      if (!state.rows.length) return;

      var rows = state.rows;
      var prev = state.prevRows;
      var spend = agg(rows, 'cost');
      var installs = has(rows, 'conversions') ? agg(rows, 'conversions') : null;
      var revCol = has(rows, 'sales') ? 'sales' : has(rows, 'revenue') ? 'revenue' : null;
      var rev = revCol ? agg(rows, revCol) : null;

      var tiles = [];

      tiles.push(
        el('div', { class: 'alv-stat' }, [
          el('div', { class: 'alv-stat__label', text: 'Số dòng' }),
          el('div', { class: 'alv-stat__value', text: rows.length.toLocaleString('en-US') }),
          el('div', { class: 'alv-stat__meta', text: state.start + ' → ' + state.end }),
        ])
      );

      if (has(rows, 'cost')) {
        tiles.push(
          el('div', { class: 'alv-stat' }, [
            el('div', { class: 'alv-stat__label', text: 'Spend' }),
            el('div', { class: 'alv-stat__value', text: fmt('cost', spend) }),
            el('div', { class: 'alv-stat__meta', text: 'toàn kỳ, USD' }),
            prev.length ? deltaNode(spend, agg(prev, 'cost'), 'cost') : null,
          ])
        );
      }

      if (installs !== null) {
        var cpi = installs > 0 ? spend / installs : null;
        tiles.push(
          el('div', { class: 'alv-stat' }, [
            el('div', { class: 'alv-stat__label', text: 'Installs' }),
            el('div', { class: 'alv-stat__value', text: fmt('conversions', installs) }),
            el('div', { class: 'alv-stat__meta', text: 'cột conversions' }),
          ])
        );
        tiles.push(
          el('div', { class: 'alv-stat' }, [
            el('div', { class: 'alv-stat__label', text: 'CPI' }),
            el('div', { class: 'alv-stat__value', text: cpi === null ? '—' : fmt('cost', cpi) }),
            el('div', { class: 'alv-stat__meta', text: 'cost / installs' }),
          ])
        );
      }

      if (rev !== null && has(rows, 'cost')) {
        var roas = spend > 0 ? (rev / spend) * 100 : null;
        tiles.push(
          el('div', { class: 'alv-stat' }, [
            el('div', { class: 'alv-stat__label', text: revCol === 'sales' ? 'Sales' : 'Doanh thu' }),
            el('div', { class: 'alv-stat__value', text: fmt(revCol, rev) }),
            el('div', {
              class: 'alv-stat__meta',
              text: roas === null ? '—' : 'ROAS gộp ' + roas.toFixed(1) + '%',
            }),
            prev.length ? deltaNode(rev, agg(prev, revCol), revCol) : null,
          ])
        );
      }

      var estTok = Math.ceil(state.dataBlock.length / 3.5);
      var estCost = (estTok * PRICE_IN) / 1e6;
      var countBtn = el('button', { class: 'alv-btn alv-btn--sm alv-btn--ghost', type: 'button', style: 'margin-top:8px', text: 'Đếm chính xác' });
      var tokMeta = el('div', { class: 'alv-stat__meta', text: 'ước tính (~$' + estCost.toFixed(3) + ' input)' });
      countBtn.addEventListener('click', async function () {
        countBtn.disabled = true;
        countBtn.textContent = 'Đang đếm...';
        try {
          var r = await callJson('/claude/count', {
            system: [{ type: 'text', text: SYSTEM_PROMPT }],
            messages: [{ role: 'user', content: state.dataBlock + '\n\nTóm tắt tình hình.' }],
          });
          var t = r.input_tokens || 0;
          tokVal.textContent = '~' + t.toLocaleString('en-US');
          tokMeta.textContent = 'chính xác (~$' + ((t * PRICE_IN) / 1e6).toFixed(3) + ' input)';
          countBtn.remove();
        } catch (e) {
          countBtn.disabled = false;
          countBtn.textContent = 'Lỗi — thử lại';
        }
      });
      var tokVal = el('div', { class: 'alv-stat__value', text: '~' + estTok.toLocaleString('en-US') });

      tiles.push(
        el('div', { class: 'alv-stat' }, [
          el('div', { class: 'alv-stat__label', text: 'Context gửi Claude' }),
          tokVal,
          tokMeta,
          countBtn,
        ])
      );

      var grid = el('div', { class: 'alv-stats' }, tiles);
      refs.stats.appendChild(grid);

      if (state.meta && state.meta.prevError) {
        refs.stats.appendChild(
          el('div', { class: 'alv-alert alv-alert--warn', html: 'Không kéo được kỳ trước: ' + esc(state.meta.prevError) })
        );
      }
    }

    /* ---------------- bieu do ---------------- */

    function seriesFor(splitDim, barMetric) {
      /* Top 5 theo tong bar-metric; phan con lai gop vao "Khac".
         Mau bam theo TEN entity (colorMap) chu khong theo thu hang,
         nen loc bot campaign khong lam doi mau nhung cai con lai. */
      if (!splitDim) return null;
      var byName = groupBy(state.rows, [splitDim]);
      var arr = [];
      byName.forEach(function (rows, name) {
        arr.push({ name: name, total: Math.abs(num(agg(rows, barMetric)) || 0) });
      });
      arr.sort(function (a, b) { return b.total - a.total; });
      var top = arr.slice(0, 5).map(function (s) { return s.name; });
      top.forEach(function (n) { seriesColor(n); });
      return { top: top, hasOther: arr.length > 5 };
    }

    /* Cot "hour" cua AppLovin co the ve duoi dang 13, "13", "13:00"
       hoac "2026-08-15 13" — quy tat ve so 0..23. */
    function hourNum(v) {
      var s = String(v === null || v === undefined ? '' : v).trim();
      if (!s) return null;
      var lead = s.match(/^(\d{1,2})\s*(?:[:h]|$)/);
      var tail = s.match(/(\d{1,2})\s*$/);
      var n = lead ? parseInt(lead[1], 10) : tail ? parseInt(tail[1], 10) : NaN;
      return isFinite(n) && n >= 0 && n <= 23 ? n : null;
    }

    function hh(n) {
      return (n < 10 ? '0' + n : String(n)) + 'h';
    }

    /* mode: 'day' | 'datetime' (ngay+gio) | 'hourofday' (gop 0..23) */
    function axisSpec(mode) {
      if (mode === 'hourofday') {
        return {
          key: function (r) { var h = hourNum(r.hour); return h === null ? '~' : String(h); },
          sort: function (a, b) { return (a === '~' ? 99 : +a) - (b === '~' ? 99 : +b); },
          label: function (k) { return k === '~' ? '?' : hh(+k); },
          title: function (k) { return k === '~' ? 'Không rõ giờ' : 'Khung ' + hh(+k) + ' — gộp mọi ngày (UTC)'; },
        };
      }
      if (mode === 'datetime') {
        return {
          key: function (r) {
            var h = hourNum(r.hour);
            return String(r.day) + 'T' + (h === null ? '~~' : h < 10 ? '0' + h : String(h));
          },
          sort: function (a, b) { return a < b ? -1 : a > b ? 1 : 0; },
          label: function (k) { return k.slice(5, 10) + ' ' + k.slice(11) + 'h'; },
          title: function (k) { return k.slice(0, 10) + ' · ' + k.slice(11) + ':00 UTC'; },
        };
      }
      return {
        key: function (r) { return String(r.day); },
        sort: function (a, b) { return a < b ? -1 : a > b ? 1 : 0; },
        label: function (k) { return k.slice(5); },
        title: function (k) { return k + ' (UTC)'; },
      };
    }

    function buildTimeSeries(barMetric, lineMetric, splitDim, mode) {
      var ax = axisSpec(mode);
      var buckets = new Map();
      state.rows.forEach(function (r) {
        var k = ax.key(r);
        if (!buckets.has(k)) buckets.set(k, []);
        buckets.get(k).push(r);
      });
      var keys = Array.from(buckets.keys()).sort(ax.sort);
      var series = seriesFor(splitDim, barMetric);

      var points = keys.map(function (d) {
        var rows = buckets.get(d);
        var parts = [];
        if (series) {
          var used = 0;
          series.top.forEach(function (name) {
            var sub = rows.filter(function (r) { return String(r[splitDim]) === name; });
            var v = sub.length ? num(agg(sub, barMetric)) : 0;
            used += v;
            parts.push({ name: name, value: v });
          });
          if (series.hasOther) {
            var all = num(agg(rows, barMetric));
            var other = all - used;
            if (other > 0.0001) parts.push({ name: '__other__', value: other });
          }
        } else {
          parts.push({ name: barMetric, value: num(agg(rows, barMetric)) });
        }
        return {
          x: d,
          label: ax.label(d),
          title: ax.title(d),
          parts: parts,
          total: parts.reduce(function (a, p) { return a + p.value; }, 0),
          line: lineMetric ? agg(rows, lineMetric) : null,
        };
      });

      return { points: points, series: series };
    }

    function svgEl(tag, attrs) {
      var n = document.createElementNS('http://www.w3.org/2000/svg', tag);
      Object.keys(attrs || {}).forEach(function (k) { n.setAttribute(k, attrs[k]); });
      return n;
    }

    function niceTicks(max) {
      if (!isFinite(max) || max <= 0) return [0, 1];
      var raw = max / 4;
      var mag = Math.pow(10, Math.floor(Math.log10(raw)));
      var step = [1, 2, 2.5, 5, 10].map(function (m) { return m * mag; }).find(function (s) { return s >= raw; }) || mag * 10;
      var ticks = [];
      for (var v = 0; v <= max * 1.0001 + step * 0.5; v += step) ticks.push(v);
      return ticks;
    }

    function drawBarChart(points, series, metric) {
      var W = 900;
      var H = 300;
      var PAD = { t: 14, r: 14, b: 34, l: 58 };
      var iw = W - PAD.l - PAD.r;
      var ih = H - PAD.t - PAD.b;

      var svg = svgEl('svg', { class: 'alv-chart', viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'none', role: 'img' });
      var maxV = Math.max.apply(null, points.map(function (p) { return p.total; }).concat([0]));
      var ticks = niceTicks(maxV);
      var top = ticks[ticks.length - 1] || 1;

      ticks.forEach(function (t) {
        var y = PAD.t + ih - (t / top) * ih;
        svg.appendChild(svgEl('line', { class: 'alv-chart__grid', x1: PAD.l, x2: W - PAD.r, y1: y, y2: y }));
        var lab = svgEl('text', { x: PAD.l - 8, y: y + 4, 'text-anchor': 'end' });
        lab.textContent = axisLabel(metric, t);
        svg.appendChild(lab);
      });

      var n = points.length || 1;
      var colW = iw / n;
      var barW = Math.max(2, Math.min(46, colW * 0.62));

      points.forEach(function (p, i) {
        var cx = PAD.l + colW * i + colW / 2;
        var yCursor = PAD.t + ih;
        p.parts.forEach(function (part, pi) {
          if (part.value <= 0) return;
          var h = (part.value / top) * ih;
          /* 2px khoang ho mau nen giua cac lop chong nhau */
          var gap = pi > 0 ? 2 : 0;
          var hh = Math.max(0, h - gap);
          if (hh <= 0) return;
          yCursor -= gap;
          var isTopSeg = pi === p.parts.length - 1;
          var r = Math.min(4, hh / 2, barW / 2);
          var rect = svgEl('path', {
            d: isTopSeg
              ? roundedTopPath(cx - barW / 2, yCursor - hh, barW, hh, r)
              : rectPath(cx - barW / 2, yCursor - hh, barW, hh),
            fill: series ? seriesColor(part.name) : 'var(--alv-s1)',
          });
          svg.appendChild(rect);
          yCursor -= hh;
        });
      });

      /* truc x: thua thot nhan de khong dam nhau */
      var every = Math.max(1, Math.ceil(n / 12));
      points.forEach(function (p, i) {
        if (i % every !== 0 && i !== n - 1) return;
        var t = svgEl('text', { x: PAD.l + colW * i + colW / 2, y: H - 12, 'text-anchor': 'middle' });
        t.textContent = p.label;
        svg.appendChild(t);
      });

      svg.appendChild(svgEl('line', { class: 'alv-chart__grid', x1: PAD.l, x2: W - PAD.r, y1: PAD.t + ih, y2: PAD.t + ih }));

      attachHover(svg, points, PAD, colW, ih, W, function (p) {
        var rowsHtml = p.parts
          .slice()
          .reverse()
          .map(function (part) {
            var nm = part.name === '__other__' ? 'Khác' : series ? part.name : labelOf(metric);
            return (
              '<div class="alv-tip__row"><i style="background:' + (series ? seriesColor(part.name) : 'var(--alv-s1)') + '"></i>' +
              esc(nm) + '<b>' + fmt(metric, part.value) + '</b></div>'
            );
          })
          .join('');
        var totalHtml = p.parts.length > 1
          ? '<div class="alv-tip__row" style="margin-top:5px;border-top:1px solid var(--alv-axis);padding-top:5px">Tổng<b>' + fmt(metric, p.total) + '</b></div>'
          : '';
        return '<div class="alv-tip__head">' + esc(p.title) + '</div>' + rowsHtml + totalHtml;
      });

      return svg;
    }

    function rectPath(x, y, w, h) {
      return 'M' + x + ' ' + y + 'h' + w + 'v' + h + 'h' + -w + 'Z';
    }

    function roundedTopPath(x, y, w, h, r) {
      var rr = Math.max(0, Math.min(r, w / 2, h));
      return (
        'M' + x + ' ' + (y + h) +
        'V' + (y + rr) +
        'a' + rr + ' ' + rr + ' 0 0 1 ' + rr + ' ' + -rr +
        'h' + (w - 2 * rr) +
        'a' + rr + ' ' + rr + ' 0 0 1 ' + rr + ' ' + rr +
        'V' + (y + h) + 'Z'
      );
    }

    function drawLineChart(points, metric) {
      var W = 900;
      var H = 260;
      var PAD = { t: 14, r: 14, b: 34, l: 58 };
      var iw = W - PAD.l - PAD.r;
      var ih = H - PAD.t - PAD.b;

      var svg = svgEl('svg', { class: 'alv-chart', viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'none', role: 'img', style: 'height:260px' });
      var vals = points.map(function (p) { return p.line; }).filter(function (v) { return v !== null && isFinite(v); });
      var maxV = vals.length ? Math.max.apply(null, vals) : 0;
      var ticks = niceTicks(maxV);
      var top = ticks[ticks.length - 1] || 1;

      ticks.forEach(function (t) {
        var y = PAD.t + ih - (t / top) * ih;
        svg.appendChild(svgEl('line', { class: 'alv-chart__grid', x1: PAD.l, x2: W - PAD.r, y1: y, y2: y }));
        var lab = svgEl('text', { x: PAD.l - 8, y: y + 4, 'text-anchor': 'end' });
        lab.textContent = axisLabel(metric, t);
        svg.appendChild(lab);
      });

      /* Moc hoa von 100% cho ROAS/retention — duong tham chieu, khong phai grid */
      if (fmtKind(metric) === 'pct' && /^(roas|ad_roas)_/.test(metric) && top >= 100) {
        var yb = PAD.t + ih - (100 / top) * ih;
        svg.appendChild(svgEl('line', { x1: PAD.l, x2: W - PAD.r, y1: yb, y2: yb, stroke: 'var(--alv-axis)', 'stroke-width': '1' }));
        var bl = svgEl('text', { x: W - PAD.r, y: yb - 6, 'text-anchor': 'end' });
        bl.textContent = 'hoà vốn 100%';
        svg.appendChild(bl);
      }

      var n = points.length || 1;
      var colW = iw / n;
      var xOf = function (i) { return PAD.l + colW * i + colW / 2; };
      var yOf = function (v) { return PAD.t + ih - (v / top) * ih; };

      var d = '';
      points.forEach(function (p, i) {
        if (p.line === null || !isFinite(p.line)) return;
        d += (d ? 'L' : 'M') + xOf(i) + ' ' + yOf(p.line);
      });
      if (d) svg.appendChild(svgEl('path', { d: d, fill: 'none', stroke: 'var(--alv-s1)', 'stroke-width': '2', 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }));

      points.forEach(function (p, i) {
        if (p.line === null || !isFinite(p.line)) return;
        /* vanh 2px mau nen thay vi vien */
        svg.appendChild(svgEl('circle', { cx: xOf(i), cy: yOf(p.line), r: 5, fill: 'var(--alv-chart-surface)' }));
        svg.appendChild(svgEl('circle', { cx: xOf(i), cy: yOf(p.line), r: 3.5, fill: 'var(--alv-s1)' }));
      });

      /* nhan truc tiep o diem cuoi thay vi so tren moi diem */
      var last = null;
      for (var i = points.length - 1; i >= 0; i -= 1) {
        if (points[i].line !== null && isFinite(points[i].line)) { last = { i: i, v: points[i].line }; break; }
      }
      if (last) {
        var lt = svgEl('text', { x: xOf(last.i) - 8, y: yOf(last.v) - 10, 'text-anchor': 'end', fill: 'var(--alv-text)' });
        lt.textContent = fmt(metric, last.v);
        svg.appendChild(lt);
      }

      var every = Math.max(1, Math.ceil(n / 12));
      points.forEach(function (p, i) {
        if (i % every !== 0 && i !== n - 1) return;
        var t = svgEl('text', { x: xOf(i), y: H - 12, 'text-anchor': 'middle' });
        t.textContent = p.label;
        svg.appendChild(t);
      });

      svg.appendChild(svgEl('line', { class: 'alv-chart__grid', x1: PAD.l, x2: W - PAD.r, y1: PAD.t + ih, y2: PAD.t + ih }));

      attachHover(svg, points, PAD, colW, ih, W, function (p) {
        return (
          '<div class="alv-tip__head">' + esc(p.title) + '</div>' +
          '<div class="alv-tip__row"><i style="background:var(--alv-s1)"></i>' + esc(labelOf(metric)) +
          '<b>' + (p.line === null ? '—' : fmt(metric, p.line)) + '</b></div>'
        );
      }, true);

      return svg;
    }

    function attachHover(svg, points, PAD, colW, ih, W, htmlFor, crosshair) {
      var cross = null;
      if (crosshair) {
        cross = svgEl('line', { y1: PAD.t, y2: PAD.t + ih, stroke: 'var(--alv-axis)', 'stroke-width': '1', opacity: '0' });
        svg.appendChild(cross);
      }
      points.forEach(function (p, i) {
        var hit = svgEl('rect', {
          class: 'alv-chart__hit',
          x: PAD.l + colW * i,
          y: PAD.t,
          width: Math.max(colW, 1),
          height: ih,
        });
        hit.addEventListener('mouseenter', function () {
          var tp = tooltipNode();
          tp.innerHTML = htmlFor(p);
          tp.classList.add('is-on');
          if (cross) {
            cross.setAttribute('x1', PAD.l + colW * i + colW / 2);
            cross.setAttribute('x2', PAD.l + colW * i + colW / 2);
            cross.setAttribute('opacity', '1');
          }
        });
        hit.addEventListener('mousemove', function (ev) {
          var tp = tooltipNode();
          tp.style.left = Math.min(ev.clientX + 14, window.innerWidth - 300) + 'px';
          tp.style.top = Math.max(8, ev.clientY - 12) + 'px';
        });
        hit.addEventListener('mouseleave', function () {
          tooltipNode().classList.remove('is-on');
          if (cross) cross.setAttribute('opacity', '0');
        });
        svg.appendChild(hit);
      });
    }

    function renderCharts() {
      refs.charts.innerHTML = '';
      if (!state.rows.length) return;

      var hasDay = has(state.rows, 'day');
      var hasHour = has(state.rows, 'hour');

      var modes = [];
      if (hasDay) modes.push(['day', 'Theo ngày']);
      if (hasDay && hasHour) modes.push(['datetime', 'Theo giờ (mốc thời gian)']);
      if (hasHour) modes.push(['hourofday', 'Giờ trong ngày (gộp 0–23h)']);

      if (!modes.length) {
        refs.charts.appendChild(
          el('div', { class: 'alv-card' }, [
            el('h3', { class: 'alv-card__title', text: 'Biểu đồ theo thời gian' }),
            el('div', {
              class: 'alv-note',
              text:
                'Cần chọn chiều "Ngày" (day)' +
                (state.reportType === 'publisher' ? ' hoặc "Giờ" (hour)' : '') +
                ' thì mới vẽ được biểu đồ theo thời gian.',
            }),
          ])
        );
        return;
      }

      if (!state.chart.mode || !modes.some(function (m) { return m[0] === state.chart.mode; })) {
        state.chart.mode = modes[0][0];
      }

      var additive = metricCols().filter(isAdditive);
      var ratios = metricCols().filter(function (m) { return !isAdditive(m); });
      if (!additive.length && !ratios.length) return;

      if (!additive.length) state.chart.bar = '';
      else if (additive.indexOf(state.chart.bar) < 0) state.chart.bar = additive[0];
      if (state.chart.line && ratios.indexOf(state.chart.line) < 0) state.chart.line = '';
      if (!state.chart.line && ratios.length) {
        state.chart.line = ratios.indexOf('roas_7d') >= 0 ? 'roas_7d' : ratios[0];
      }

      var splitOpts = state.dims.filter(function (d) { return d !== 'day' && d !== 'hour'; });
      if (state.chart.split && splitOpts.indexOf(state.chart.split) < 0) state.chart.split = '';
      if (!state.chart.split && splitOpts.indexOf('campaign') >= 0) state.chart.split = 'campaign';

      function sel(list, cur, onPick, allowNone, noneLabel) {
        var s = el('select', { class: 'alv-select' });
        if (allowNone) s.appendChild(el('option', { value: '', selected: !cur, text: noneLabel }));
        list.forEach(function (id) {
          s.appendChild(el('option', { value: id, selected: cur === id, text: labelOf(id) }));
        });
        s.addEventListener('change', function () { onPick(s.value); renderCharts(); });
        return s;
      }

      var modeSel = el('select', { class: 'alv-select' });
      modes.forEach(function (m) {
        modeSel.appendChild(el('option', { value: m[0], selected: state.chart.mode === m[0], text: m[1] }));
      });
      modeSel.addEventListener('change', function () {
        state.chart.mode = modeSel.value;
        renderCharts();
      });

      var controls = el('div', { class: 'alv-row', style: 'margin-bottom:18px' }, [
        el('div', { class: 'alv-field' }, [
          el('label', { class: 'alv-label', text: 'Trục thời gian' }),
          modeSel,
        ]),
        additive.length
          ? el('div', { class: 'alv-field' }, [
              el('label', { class: 'alv-label', text: 'Cột (cộng dồn)' }),
              sel(additive, state.chart.bar, function (v) { state.chart.bar = v; }),
            ])
          : null,
        splitOpts.length
          ? el('div', { class: 'alv-field' }, [
              el('label', { class: 'alv-label', text: 'Tách theo' }),
              sel(splitOpts, state.chart.split, function (v) { state.chart.split = v; state.colorMap = {}; }, true, 'Không tách'),
            ])
          : null,
        ratios.length
          ? el('div', { class: 'alv-field' }, [
              el('label', { class: 'alv-label', text: 'Đường (tỷ lệ)' }),
              sel(ratios, state.chart.line, function (v) { state.chart.line = v; }, true, 'Không vẽ'),
            ])
          : null,
      ]);

      var ts = buildTimeSeries(state.chart.bar, state.chart.line, state.chart.split, state.chart.mode);
      var perLabel =
        state.chart.mode === 'datetime' ? 'theo giờ' : state.chart.mode === 'hourofday' ? 'theo khung giờ' : 'theo ngày';

      var card = el('div', { class: 'alv-card' }, [
        el('h3', { class: 'alv-card__title', text: 'Biểu đồ theo thời gian' }),
        controls,
        !hasHour && state.reportType === 'advertiser'
          ? el('div', { class: 'alv-note', style: 'margin-bottom:18px' }, [
              document.createTextNode('Report '),
              el('strong', { text: 'advertiser' }),
              document.createTextNode(' của AppLovin không có chiều '),
              el('code', { text: 'hour' }),
              document.createTextNode(' — nhỏ nhất là theo ngày. Chiều giờ chỉ tồn tại ở report '),
              el('strong', { text: 'publisher (MAX)' }),
              document.createTextNode(', và cũng chỉ trong 30 ngày gần nhất.'),
            ])
          : null,
      ]);

      if (state.chart.bar) {
        var figA = el('div', { class: 'alv-figure', style: 'margin-bottom:30px' }, [
          el('p', { class: 'alv-figure__title', text: labelOf(state.chart.bar) + ' ' + perLabel + (state.chart.split ? ' — tách theo ' + labelOf(state.chart.split) : '') }),
          el('p', {
            class: 'alv-figure__sub',
            text:
              state.chart.mode === 'hourofday'
                ? 'Cộng dồn mọi ngày trong kỳ ' + state.start + ' → ' + state.end + ' theo từng khung giờ (UTC)'
                : state.start + ' → ' + state.end + ' (UTC)',
          }),
        ]);
        figA.appendChild(drawBarChart(ts.points, ts.series, state.chart.bar));
        if (ts.series) {
          var legend = el('div', { class: 'alv-legend' });
          ts.series.top.forEach(function (nm) {
            legend.appendChild(el('span', {}, [el('i', { style: 'background:' + seriesColor(nm) }), nm]));
          });
          if (ts.series.hasOther) {
            legend.appendChild(el('span', {}, [el('i', { style: 'background:var(--alv-s-other)' }), 'Khác']));
          }
          figA.appendChild(legend);
        }
        card.appendChild(figA);
      }

      if (state.chart.line) {
        var figB = el('div', { class: 'alv-figure' }, [
          el('p', { class: 'alv-figure__title', text: labelOf(state.chart.line) + ' ' + perLabel }),
          el('p', {
            class: 'alv-figure__sub',
            text: isCohort(state.chart.line)
              ? 'Chỉ số cohort — những ngày gần cuối kỳ chưa chín, con số sẽ còn tăng.'
              : 'Tính lại từ tử số / mẫu số, không phải trung bình cộng.',
          }),
        ]);
        figB.appendChild(drawLineChart(ts.points, state.chart.line));
        card.appendChild(figB);
      }

      refs.charts.appendChild(card);
    }

    /* ---------------- bang tong hop (pivot) ---------------- */

    function renderPivot() {
      refs.pivot.innerHTML = '';
      if (!state.rows.length) return;

      var dimOpts = state.dims.filter(function (d) { return d !== 'day'; });
      if (!dimOpts.length) return;
      if (!state.pivotDim || dimOpts.indexOf(state.pivotDim) < 0) state.pivotDim = dimOpts[0];

      var sel = el('select', { class: 'alv-select' });
      dimOpts.forEach(function (d) {
        sel.appendChild(el('option', { value: d, selected: state.pivotDim === d, text: labelOf(d) }));
      });
      sel.addEventListener('change', function () { state.pivotDim = sel.value; renderPivot(); });

      var mets = metricCols();
      var groups = groupBy(state.rows, [state.pivotDim]);
      var prevGroups = state.prevRows.length ? groupBy(state.prevRows, [state.pivotDim]) : null;

      var list = [];
      groups.forEach(function (rows, name) {
        var rec = { name: name, n: rows.length, vals: {} };
        mets.forEach(function (m) { rec.vals[m] = agg(rows, m); });
        if (prevGroups && prevGroups.has(name)) {
          rec.prev = {};
          mets.forEach(function (m) { rec.prev[m] = agg(prevGroups.get(name), m); });
        }
        list.push(rec);
      });

      var sortKey = has(state.rows, 'cost') ? 'cost' : mets[0];
      list.sort(function (a, b) { return num(b.vals[sortKey]) - num(a.vals[sortKey]); });

      var thead = el('tr', {}, [
        el('th', { text: labelOf(state.pivotDim) }),
        el('th', { class: 'is-num', text: 'Dòng' }),
      ]);
      mets.forEach(function (m) { thead.appendChild(el('th', { class: 'is-num', text: labelOf(m) })); });

      var tbody = el('tbody');
      list.forEach(function (rec) {
        var tr = el('tr', {}, [el('td', { text: rec.name }), el('td', { class: 'is-num', text: String(rec.n) })]);
        mets.forEach(function (m) {
          var td = el('td', { class: 'is-num' }, [document.createTextNode(fmt(m, rec.vals[m]))]);
          if (rec.prev && rec.prev[m] !== null && isFinite(rec.prev[m]) && rec.prev[m] !== 0) {
            var pct = ((num(rec.vals[m]) - rec.prev[m]) / Math.abs(rec.prev[m])) * 100;
            if (Math.abs(pct) >= 0.5) {
              td.appendChild(
                el('div', {
                  class: 'alv-delta alv-delta--' + (pct > 0 ? 'up' : 'down'),
                  style: 'font-size:11px;margin-top:2px',
                  text: (pct > 0 ? '+' : '') + pct.toFixed(0) + '%',
                })
              );
            }
          }
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });

      var tfootRow = el('tr', {}, [
        el('td', { text: 'TỔNG' }),
        el('td', { class: 'is-num', text: String(state.rows.length) }),
      ]);
      mets.forEach(function (m) { tfootRow.appendChild(el('td', { class: 'is-num', text: fmt(m, agg(state.rows, m)) })); });

      refs.pivot.appendChild(
        el('div', { class: 'alv-card' }, [
          el('h3', { class: 'alv-card__title', text: '2. Bảng tổng hợp' }),
          el('div', { class: 'alv-row', style: 'margin-bottom:14px' }, [
            el('div', { class: 'alv-field' }, [el('label', { class: 'alv-label', text: 'Gộp theo' }), sel]),
          ]),
          el('div', { class: 'alv-note', style: 'margin-bottom:14px' }, [
            document.createTextNode('Chi phí / lượt / doanh thu được '),
            el('strong', { text: 'cộng dồn' }),
            document.createTextNode('; CTR, CVR, CPA, CPC được '),
            el('strong', { text: 'tính lại từ tử số và mẫu số' }),
            document.createTextNode('; ROAS lấy trung bình có trọng số theo chi phí (= tổng doanh thu / tổng chi phí); retention theo số install. Không có chỗ nào lấy trung bình cộng của tỷ lệ.'),
          ]),
          el('div', { class: 'alv-tablewrap' }, [
            el('table', { class: 'alv-table' }, [
              el('thead', {}, [thead]),
              tbody,
              el('tfoot', {}, [tfootRow]),
            ]),
          ]),
        ])
      );
    }

    /* ---------------- bang tho ---------------- */

    function renderTable() {
      refs.table.innerHTML = '';
      if (!state.rows.length) {
        refs.table.appendChild(
          el('div', { class: 'alv-card' }, [
            el('h3', { class: 'alv-card__title', text: '3. Dữ liệu thô' }),
            el('div', { class: 'alv-empty', text: 'Chưa có dữ liệu. Bấm "Kéo dữ liệu" ở trên.' }),
          ])
        );
        return;
      }

      var cols = Object.keys(state.rows[0]);
      var rows = state.rows.slice();
      if (state.sort.col) {
        var c = state.sort.col;
        var dir = state.sort.dir;
        rows.sort(function (a, b) {
          var av = a[c];
          var bv = b[c];
          if (typeof av === 'number' || typeof bv === 'number') return (num(av) - num(bv)) * dir;
          return String(av).localeCompare(String(bv)) * dir;
        });
      }

      var thead = el('tr');
      cols.forEach(function (c) {
        var isNum = state.mets.indexOf(c) >= 0 || isCohort(c);
        var th = el('th', {
          class: (isNum ? 'is-num' : '') + (state.sort.col === c ? ' is-sorted' : ''),
          title: c,
          text: c + (state.sort.col === c ? (state.sort.dir === 1 ? ' ↑' : ' ↓') : ''),
        });
        th.addEventListener('click', function () {
          if (state.sort.col === c) state.sort.dir *= -1;
          else state.sort = { col: c, dir: -1 };
          renderTable();
        });
        thead.appendChild(th);
      });

      var tbody = el('tbody');
      rows.forEach(function (r) {
        var tr = el('tr');
        cols.forEach(function (c) {
          var isNum = state.mets.indexOf(c) >= 0 || isCohort(c);
          tr.appendChild(el('td', { class: isNum ? 'is-num' : '', text: isNum ? fmt(c, r[c]) : String(r[c] === undefined ? '' : r[c]) }));
        });
        tbody.appendChild(tr);
      });

      var csvBtn = el('button', { class: 'alv-btn alv-btn--sm', type: 'button', text: 'Tải CSV' });
      csvBtn.addEventListener('click', function () { downloadCsv(rows, cols); });

      refs.table.appendChild(
        el('div', { class: 'alv-card' }, [
          el('h3', { class: 'alv-card__title', text: '3. Dữ liệu thô' }),
          el('div', { class: 'alv-table__meta' }, [
            document.createTextNode(state.rows.length.toLocaleString('en-US') + ' dòng · bấm tên cột để sắp xếp'),
            el('div', { class: 'alv-spacer' }),
            csvBtn,
          ]),
          el('div', { class: 'alv-tablewrap' }, [
            el('table', { class: 'alv-table' }, [el('thead', {}, [thead]), tbody]),
          ]),
        ])
      );
    }

    function toCsv(rows, cols) {
      var lines = [cols.join(',')];
      rows.forEach(function (r) {
        lines.push(
          cols
            .map(function (c) {
              var v = r[c];
              if (v === null || v === undefined) return '';
              var s = String(v);
              return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
            })
            .join(',')
        );
      });
      return lines.join('\n');
    }

    function downloadCsv(rows, cols) {
      var blob = new Blob([toCsv(rows, cols)], { type: 'text/csv;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = el('a', { href: url, download: 'applovin-' + state.start + '_' + state.end + '.csv' });
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }

    /* ================================================================
       11. CONTEXT gui Claude
       ================================================================ */

    function buildDataBlock() {
      if (!state.rows.length) { state.dataBlock = ''; return; }

      var cols = Object.keys(state.rows[0]);
      var mets = metricCols();
      var lines = [];

      lines.push('# BÁO CÁO APPLOVIN');
      lines.push('- Loại report: ' + (state.reportType === 'publisher' ? 'publisher (MAX)' : 'advertiser (AppDiscovery)'));
      lines.push('- Kỳ báo cáo (UTC): ' + state.start + ' → ' + state.end + ' (' + (daysBetween(state.start, state.end) + 1) + ' ngày)');
      lines.push('- Hôm nay (UTC): ' + isoDate(utcToday()));
      lines.push('- Chiều dữ liệu: ' + (state.dims.join(', ') || '(không)'));
      lines.push('- Chỉ số: ' + (mets.join(', ') || '(không)'));
      var activeFilters = Object.keys(state.filters).filter(function (k) { return String(state.filters[k] || '').trim(); });
      if (activeFilters.length) {
        lines.push('- Bộ lọc: ' + activeFilters.map(function (k) { return k + '=' + state.filters[k]; }).join('; '));
      }
      if (state.notZero) lines.push('- Đã bỏ các dòng có toàn bộ chỉ số bằng 0.');
      if (cols.some(isCohort)) {
        lines.push('- Có chỉ số cohort → request dùng day_column=day (gán theo ngày acquire).');
      }
      if (has(state.rows, 'hour')) {
        lines.push('- Có chiều `hour` (0–23, giờ UTC — cộng 7 để ra giờ Việt Nam). AppLovin chỉ trả dữ liệu theo giờ cho 30 ngày gần nhất.');
      }
      lines.push('- Số dòng: ' + state.rows.length);
      lines.push('');

      lines.push('## TỔNG TOÀN KỲ');
      mets.forEach(function (m) { lines.push('- ' + m + ': ' + fmt(m, agg(state.rows, m))); });

      if (state.prevRows.length && state.meta && state.meta.prevStart) {
        lines.push('');
        lines.push('## TỔNG KỲ TRƯỚC (' + state.meta.prevStart + ' → ' + state.meta.prevEnd + ') — để so sánh');
        mets.forEach(function (m) { lines.push('- ' + m + ': ' + fmt(m, agg(state.prevRows, m))); });
      }

      var pivotDim = state.dims.filter(function (d) { return d !== 'day'; })[0];
      if (pivotDim) {
        lines.push('');
        lines.push('## TỔNG HỢP THEO ' + pivotDim.toUpperCase());
        var g = groupBy(state.rows, [pivotDim]);
        var arr = [];
        g.forEach(function (rws, name) {
          var rec = { name: name };
          mets.forEach(function (m) { rec[m] = agg(rws, m); });
          arr.push(rec);
        });
        var sk = has(state.rows, 'cost') ? 'cost' : mets[0];
        arr.sort(function (a, b) { return num(b[sk]) - num(a[sk]); });
        lines.push([pivotDim].concat(mets).join(','));
        arr.forEach(function (rec) {
          lines.push([rec.name].concat(mets.map(function (m) {
            return rec[m] === null || rec[m] === undefined ? '' : Number(rec[m]).toFixed(4).replace(/\.?0+$/, '');
          })).join(','));
        });
      }

      lines.push('');
      lines.push('## DỮ LIỆU THÔ (CSV)');

      var header = cols.join(',');
      var body = [];
      var budget = MAX_CTX_CHARS - lines.join('\n').length - header.length - 400;
      var used = 0;
      var kept = 0;

      for (var i = 0; i < state.rows.length; i += 1) {
        var line = cols
          .map(function (c) {
            var v = state.rows[i][c];
            if (v === null || v === undefined) return '';
            var s = String(v);
            return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
          })
          .join(',');
        if (used + line.length + 1 > budget) break;
        body.push(line);
        used += line.length + 1;
        kept += 1;
      }

      lines.push(header);
      lines.push(body.join('\n'));
      if (kept < state.rows.length) {
        lines.push('');
        lines.push('(Đã cắt bớt: chỉ gửi ' + kept + '/' + state.rows.length + ' dòng đầu do giới hạn độ dài. Phần TỔNG ở trên tính trên TOÀN BỘ ' + state.rows.length + ' dòng.)');
      }

      state.dataBlock = lines.join('\n');
    }

    /* ================================================================
       12. PANEL CLAUDE
       ================================================================ */

    var QUICK = [
      'Tóm tắt tình hình kỳ này và chỉ ra 3 điều đáng chú ý nhất.',
      'Campaign nào nên tăng ngân sách, campaign nào nên cắt? Giải thích bằng số.',
      'So sánh với kỳ trước: cái gì thay đổi thật, cái gì chỉ là nhiễu?',
      'ROAS đang đi về đâu? Cohort nào đã đủ chín để tin?',
      'Có dấu hiệu bất thường nào trong dữ liệu không (spike, drop, chỉ số lệch)?',
    ];

    function renderClaude() {
      refs.claude.innerHTML = '';

      var chatBox = el('div', { class: 'alv-chat' });
      refs.chatBox = chatBox;

      if (!state.chat.length) {
        chatBox.appendChild(
          el('div', { class: 'alv-empty', text: state.rows.length ? 'Đặt câu hỏi về dữ liệu ở dưới.' : 'Kéo dữ liệu trước rồi hỏi Claude.' })
        );
      } else {
        state.chat.forEach(function (m) { chatBox.appendChild(msgNode(m)); });
      }

      var quick = el('div', { class: 'alv-quick' });
      QUICK.forEach(function (q) {
        var b = el('button', { class: 'alv-chip', type: 'button', text: q });
        b.addEventListener('click', function () { ask(q); });
        quick.appendChild(b);
      });

      var ta = el('textarea', { class: 'alv-textarea', placeholder: 'Hỏi Claude về dữ liệu này...' });
      refs.ta = ta;
      ta.addEventListener('keydown', function (e) {
        if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') { e.preventDefault(); ask(ta.value); }
      });

      var effortSel = el('select', { class: 'alv-select' });
      [['low', 'Nhanh'], ['medium', 'Cân bằng'], ['high', 'Kỹ (mặc định)'], ['xhigh', 'Rất kỹ']].forEach(function (o) {
        effortSel.appendChild(el('option', { value: o[0], selected: (store(NS + 'effort') || 'high') === o[0], text: o[1] }));
      });
      effortSel.addEventListener('change', function () { store(NS + 'effort', effortSel.value); });
      refs.effort = effortSel;

      var sendBtn = el('button', { class: 'alv-btn alv-btn--primary', type: 'button', text: 'Gửi cho Claude' });
      sendBtn.addEventListener('click', function () { ask(ta.value); });
      refs.sendBtn = sendBtn;

      var stopBtn = el('button', { class: 'alv-btn alv-btn--danger alv-hide', type: 'button', text: 'Dừng' });
      stopBtn.addEventListener('click', function () { if (state.abort) state.abort.abort(); });
      refs.stopBtn = stopBtn;

      var clearBtn = el('button', { class: 'alv-btn alv-btn--ghost alv-btn--sm', type: 'button', text: 'Xoá hội thoại' });
      clearBtn.addEventListener('click', function () { state.chat = []; renderClaude(); });

      refs.usage = el('div', { class: 'alv-hint', style: 'align-self:center' });

      refs.claude.appendChild(
        el('div', { class: 'alv-card' }, [
          el('h3', { class: 'alv-card__title', text: '4. Phân tích bằng Claude Opus 5' }),
          el('div', { class: 'alv-note', style: 'margin-bottom:14px' }, [
            document.createTextNode('Toàn bộ bảng ở trên (kèm phần tổng đã tính sẵn) được gửi cùng câu hỏi. API key của Anthropic nằm trong biến môi trường của worker, '),
            el('strong', { text: 'không' }),
            document.createTextNode(' có trong code theme.'),
          ]),
          chatBox,
          quick,
          ta,
          el('div', { class: 'alv-row', style: 'margin-top:12px' }, [
            el('div', { class: 'alv-field', style: 'flex:0 1 170px' }, [
              el('label', { class: 'alv-label', text: 'Mức độ suy luận' }),
              effortSel,
            ]),
            el('div', {}, [sendBtn]),
            el('div', {}, [stopBtn]),
            refs.usage,
            el('div', { class: 'alv-spacer' }),
            el('div', {}, [clearBtn]),
          ]),
          el('div', { class: 'alv-hint', style: 'margin-top:10px', text: 'Ctrl/⌘ + Enter để gửi nhanh.' }),
        ])
      );
    }

    function msgNode(m) {
      if (m.role === 'user') {
        return el('div', { class: 'alv-msg alv-msg--user' }, [
          el('div', { class: 'alv-msg__who', text: 'Bạn' }),
          el('div', { text: m.text }),
        ]);
      }
      var box = el('div', { class: 'alv-msg alv-msg--ai' }, [el('div', { class: 'alv-msg__who', text: 'Claude Opus 5' })]);
      if (m.thinking) {
        box.appendChild(
          el('details', { class: 'alv-think' }, [
            el('summary', { text: 'Quá trình suy luận (tóm tắt)' }),
            el('div', { class: 'alv-think__body', text: m.thinking }),
          ])
        );
      }
      box.appendChild(el('div', { class: 'alv-md', html: mdToHtml(m.text) }));
      return box;
    }

    async function ask(question) {
      var q = String(question || '').trim();
      if (!q) return;
      if (!state.rows.length) { window.alert('Kéo dữ liệu trước đã.'); return; }
      if (state.abort) return;

      refs.ta.value = '';
      state.chat.push({ role: 'user', text: q });

      var aiMsg = { role: 'assistant', text: '', thinking: '' };
      state.chat.push(aiMsg);

      if (refs.chatBox.querySelector('.alv-empty')) refs.chatBox.innerHTML = '';
      refs.chatBox.appendChild(msgNode({ role: 'user', text: q }));

      var aiBox = el('div', { class: 'alv-msg alv-msg--ai' }, [el('div', { class: 'alv-msg__who', text: 'Claude Opus 5' })]);
      var thinkBody = el('div', { class: 'alv-think__body' });
      var thinkWrap = el('details', { class: 'alv-think alv-hide' }, [
        el('summary', { text: 'Quá trình suy luận (tóm tắt)' }),
        thinkBody,
      ]);
      var mdBox = el('div', { class: 'alv-md alv-cursor' });
      aiBox.appendChild(thinkWrap);
      aiBox.appendChild(mdBox);
      refs.chatBox.appendChild(aiBox);
      refs.chatBox.scrollTop = refs.chatBox.scrollHeight;

      refs.sendBtn.disabled = true;
      refs.stopBtn.classList.remove('alv-hide');
      state.abort = new AbortController();

      /* Khoi du lieu di kem tin nhan dau tien va duoc cache lai,
         nen cac cau hoi tiep theo chi tra tien doc cache. */
      var msgs = [];
      state.chat
        .filter(function (m) { return m.role === 'user' || (m.role === 'assistant' && m.text); })
        .forEach(function (m, idx) {
          if (m.role === 'user' && idx === 0) {
            msgs.push({
              role: 'user',
              content: [
                { type: 'text', text: state.dataBlock, cache_control: { type: 'ephemeral' } },
                { type: 'text', text: m.text },
              ],
            });
          } else {
            msgs.push({ role: m.role, content: m.text });
          }
        });

      var inTok = 0;
      var outTok = 0;

      try {
        var res = await callProxy(
          '/claude',
          {
            system: [{ type: 'text', text: SYSTEM_PROMPT, cache_control: { type: 'ephemeral' } }],
            messages: msgs,
            effort: refs.effort.value,
          },
          state.abort.signal
        );

        if (!res.ok || !res.body) {
          var errText = await res.text();
          var parsed;
          try { parsed = JSON.parse(errText); } catch (e) { parsed = { error: errText.slice(0, 300) }; }
          throw new Error(parsed.error || 'Lỗi ' + res.status);
        }

        var reader = res.body.getReader();
        var dec = new TextDecoder();
        var buf = '';

        for (;;) {
          var chunk = await reader.read();
          if (chunk.done) break;
          buf += dec.decode(chunk.value, { stream: true });
          var blocks = buf.split('\n\n');
          buf = blocks.pop();

          for (var bi = 0; bi < blocks.length; bi += 1) {
            var dataLines = blocks[bi].split('\n').filter(function (l) { return l.indexOf('data:') === 0; });
            for (var li = 0; li < dataLines.length; li += 1) {
              var payload = dataLines[li].slice(5).trim();
              if (!payload) continue;
              var ev;
              try { ev = JSON.parse(payload); } catch (e) { continue; }

              if (ev.type === 'message_start' && ev.message && ev.message.usage) {
                inTok = (ev.message.usage.input_tokens || 0) +
                  (ev.message.usage.cache_read_input_tokens || 0) +
                  (ev.message.usage.cache_creation_input_tokens || 0);
              } else if (ev.type === 'content_block_delta' && ev.delta) {
                if (ev.delta.type === 'text_delta') {
                  aiMsg.text += ev.delta.text;
                  mdBox.innerHTML = mdToHtml(aiMsg.text);
                  refs.chatBox.scrollTop = refs.chatBox.scrollHeight;
                } else if (ev.delta.type === 'thinking_delta') {
                  aiMsg.thinking += ev.delta.thinking || '';
                  thinkWrap.classList.remove('alv-hide');
                  thinkBody.textContent = aiMsg.thinking;
                }
              } else if (ev.type === 'message_delta' && ev.usage) {
                outTok = ev.usage.output_tokens || outTok;
              } else if (ev.type === 'error') {
                throw new Error((ev.error && ev.error.message) || 'Anthropic báo lỗi.');
              }
            }
          }
        }

        if (!aiMsg.text) aiMsg.text = '_(Claude không trả về nội dung nào.)_';
        mdBox.innerHTML = mdToHtml(aiMsg.text);
      } catch (e) {
        if (e.name === 'AbortError') {
          aiMsg.text += '\n\n_(Đã dừng.)_';
          mdBox.innerHTML = mdToHtml(aiMsg.text);
        } else {
          aiMsg.text = 'Lỗi: ' + e.message;
          mdBox.innerHTML = '';
          mdBox.appendChild(el('div', { class: 'alv-alert alv-alert--err', html: esc(aiMsg.text) }));
        }
      } finally {
        mdBox.classList.remove('alv-cursor');
        state.abort = null;
        refs.sendBtn.disabled = false;
        refs.stopBtn.classList.add('alv-hide');
        if (inTok || outTok) {
          var cost = (inTok * PRICE_IN + outTok * PRICE_OUT) / 1e6;
          refs.usage.textContent =
            inTok.toLocaleString('en-US') + ' in / ' + outTok.toLocaleString('en-US') + ' out · ~$' + cost.toFixed(4);
        }
      }
    }

    /* ================================================================
       13. BOOT
       ================================================================ */

    (async function start() {
      state.health = await probeHealth();

      /* Vao thang neu da co du dieu kien goi API:
         co URL proxy VA (key da luu tren may HOAC worker giu san key). */
      if (state.proxyUrl && (state.reportKey || serverHasKey())) {
        renderApp();
        fetchReport();
      } else {
        renderGate();
      }
    })();
  }

  function boot() {
    document.querySelectorAll('[data-alv-root]').forEach(function (root) {
      if (root.dataset.alvReady === '1') return;
      root.dataset.alvReady = '1';
      try {
        init(root);
      } catch (e) {
        root.innerHTML = '<div class="alv-alert alv-alert--err">Không khởi tạo được tool: ' + esc(e.message) + '</div>';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
